import AnalysisKeiCurrentBefore from 'views/Analysis/AnalysisKeiCurrentBefore';
import AnalysisKeiBigSmall from 'views/Analysis/AnalysisKeiBigSmall';

import { ComparisonKind } from 'views/Analysis/analysisUtils';

// 分析（契約件数）
function AnalysisKei(props) {
  // 分析情報
  const quoteList = props.quoteList;
  // 選択中の期
  const selectedPeriod = props.selectedPeriod;
  // 移動年計
  const mat = props.movingAnnualTotal?.keiyaku ?? [];

  // 昨対比 or 工事／管・小
  return props.comparisonKind === ComparisonKind.CURRENT_BEFORE ? (
    <AnalysisKeiCurrentBefore
      quoteList={quoteList}
      selectedPeriod={selectedPeriod}
      movingAnnualTotal={mat}
    ></AnalysisKeiCurrentBefore>
  ) : (
    <AnalysisKeiBigSmall
      quoteList={quoteList}
      selectedPeriod={selectedPeriod}
      movingAnnualTotal={mat}
    ></AnalysisKeiBigSmall>
  );
}
export default AnalysisKei;
